import { Component, DoCheck, OnInit } from '@angular/core';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { AlertService, AuthenticationService } from 'src/app/shared/_services';
import { AddCashierPage } from 'src/app/shared/modals/add-cashier/add-cashier.page';
import { CloseOverlayService } from 'src/app/shared/_services/closeOverlay.service';
import { Router } from '@angular/router';
import { CashiersStore } from 'src/app/shared/_services/store';
@Component({
  selector: 'app-cashiers',
  templateUrl: './cashiers.page.html',
  styleUrls: ['./cashiers.page.scss'],
})
export class CashiersPage implements OnInit, DoCheck {
  cashiers = [];
  cashierName: any;
  cashierPhone: any;
  cashierEmail: any;
  cashierId: any;
  currentUser: any;
  subscription: any;

  constructor(
    private auth: AuthenticationService,
    private alertController: AlertController,
    private modalController: ModalController,
    private cashiersStore: CashiersStore,
    private alertService: AlertService,
    private platform: Platform,
    private router: Router,
    private closeOverlayService: CloseOverlayService
  ) {
    this.cashiers = this.cashiersStore.getCashiers();
  }

  async addNewCashier() {
    const modal = await this.modalController.create({
      component: AddCashierPage,
      cssClass: 'bottom-modal create-dispute h-50',
      backdropDismiss: true,
      swipeToClose: true,
    });
    return await modal.present();
  }

  async editCashier(cashier: any) {
    const alert = await this.alertController.create({
      header: 'Cashier Details',
      inputs: [
        {
          name: 'name',
          placeholder: 'Cashier\'s Name',
          value: cashier.name,
          disabled: true,
        },
        {
          name: 'phone',
          placeholder: 'Phone Number',
          value: cashier.phone,
          disabled: true,
        },
        {
          name: 'email',
          placeholder: 'Email Address',
          value: cashier.email,
          disabled: true,
        },
        {
          name: 'id',
          value: cashier.id,
          attributes: {
            hidden: true,
          },
        },
      ],
      buttons: [
        {
          text: 'Delete',
          cssClass: 'text-danger del-cashier',
          handler: (value) => {
            console.log(value);
            this.cashierId = value;
            this.confirmDeletion();
          },
        },
        // {
        //   text: 'Save Details',
        // }
      ],
      backdropDismiss: true,
    });

    await alert.present();
  }

  async confirmDeletion() {
    const alert = await this.alertController.create({
      header: 'Confirm Deletion',
      message:
        'Taking this action would delete this Cashier\'s account permanently but keep their transaction records',
      buttons: [
        {
          text: 'Delete',
          cssClass: 'mg-auto alert-button-md alert-button-ios',
          handler: () => {
            const cashier = this.cashierId;
            console.log(cashier.id);
            this.alertService.loading('Deleting Cashier...');
            this.auth.deleteCashier(cashier.id).subscribe(
              (response) => {
                console.log(response);
                this.alertService.stopLoading();
                this.alertService.standardAlertWithButton(
                  '',
                  'Cashier Deleted Successfully!',
                  true,
                  'Ok'
                );
                this.getCashiers();
              },
              (error) => {
                this.alertService.stopLoading();
                console.log(error);
                if (error.status === 422) {
                  this.alertService.standardAlert(
                    'Unable to delete Cashier at the moment. Please try again'
                  );
                }
              }
            );
          },
        },
      ],
      backdropDismiss: true,
    });

    await alert.present();
  }

  getCashiers() {
    this.auth.getCashiers().subscribe((response: any) => {
      console.log(response);
      this.storeCashierDetails(response);
    });
  }

  refreshCashiers(getCashiers: any) {
    console.log('Getting All Cashiers');
    this.auth.getCashiers().subscribe((response: any) => {
      this.storeCashierDetails(response);
      console.log('Cashiers updated');
      getCashiers.target.complete();
    });
  }

  storeCashierDetails(response: any) {
    this.cashiersStore.setCashiers(response);
    this.cashiers = this.cashiersStore.getCashiers();
  }

  goBack() {
    this.router.navigateByUrl('/dashboard');
  }

  ionViewWillEnter() {
    document.title = 'Cashiers | Bank3D';
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(
      99999,
      () => {
        if (this.constructor.name === 'CashiersPage') {
          this.alertService.checkForAlert();
        } else {
          this.goBack();
        }
      }
    );
  }

  ionViewWillLeave() {}

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.getCashiers();
    window.onpopstate = () => {
      this.alertService.checkForAlert();
      this.closeOverlayService.trigger();
    };
  }

  ngDoCheck(): void {
    if (this.cashiersStore.getIsCashierAdded() === 'true') {
      this.getCashiers();
      this.cashiersStore.setIsCashierAdded(false);
    }
  }
}
